import { useState } from 'react';

export type UseDisclosureReturn = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOpen: () => void;
  onClose: () => void;
};

export const useDisclosure = (defaultOpen = false): UseDisclosureReturn => {
  const [open, setOpen] = useState(defaultOpen);

  return {
    open,
    onOpenChange: (open: boolean) => setOpen(open),
    onOpen: () => {
      if (open) return;
      setOpen(true);
    },
    onClose: () => {
      if (!open) return;
      setOpen(false);
    },
  };
};
